import { URL } from '../../constants/provider/constant';
import { _axios } from '../../plugins/axios';


export const requestHistory = (requestId) => {
  let data = {
        requestId : parseInt(requestId),
        RequestAccessToken : JSON.parse(localStorage.getItem("access_token"))
   }
  let config = {
    method: 'post',
    url: URL.providercore_url+'provider/requestFlow',
    headers: {
      accesstoken: JSON.parse(localStorage.getItem("access_token")),
      'content-type': 'application/json;charset=UTF-8'
    },
    data: data
  };
  return _axios(config)
    .then((response) => response.data )
    .catch((error) => error);
}